/**
 * @fileoverview gRPC-Web generated client stub for api
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v4.24.2
// source: service_centre.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as service_centre_pb from './service_centre_pb';


export class ServiceCentreServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorGetServiceCentresList = new grpcWeb.MethodDescriptor(
    '/api.ServiceCentreService/GetServiceCentresList',
    grpcWeb.MethodType.UNARY,
    service_centre_pb.GetServiceCentresListRequest,
    service_centre_pb.GetServiceCentresListResponse,
    (request: service_centre_pb.GetServiceCentresListRequest) => {
      return request.serializeBinary();
    },
    service_centre_pb.GetServiceCentresListResponse.deserializeBinary
  );

  getServiceCentresList(
    request: service_centre_pb.GetServiceCentresListRequest,
    metadata: grpcWeb.Metadata | null): Promise<service_centre_pb.GetServiceCentresListResponse>;

  getServiceCentresList(
    request: service_centre_pb.GetServiceCentresListRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: service_centre_pb.GetServiceCentresListResponse) => void): grpcWeb.ClientReadableStream<service_centre_pb.GetServiceCentresListResponse>;

  getServiceCentresList(
    request: service_centre_pb.GetServiceCentresListRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: service_centre_pb.GetServiceCentresListResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/api.ServiceCentreService/GetServiceCentresList',
        request,
        metadata || {},
        this.methodDescriptorGetServiceCentresList,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/api.ServiceCentreService/GetServiceCentresList',
    request,
    metadata || {},
    this.methodDescriptorGetServiceCentresList);
  }

  methodDescriptorAddServiceCentre = new grpcWeb.MethodDescriptor(
    '/api.ServiceCentreService/AddServiceCentre',
    grpcWeb.MethodType.UNARY,
    service_centre_pb.AddServiceCentreRequest,
    service_centre_pb.AddServiceCentreResponse,
    (request: service_centre_pb.AddServiceCentreRequest) => {
      return request.serializeBinary();
    },
    service_centre_pb.AddServiceCentreResponse.deserializeBinary
  );

  addServiceCentre(
    request: service_centre_pb.AddServiceCentreRequest,
    metadata: grpcWeb.Metadata | null): Promise<service_centre_pb.AddServiceCentreResponse>;

  addServiceCentre(
    request: service_centre_pb.AddServiceCentreRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: service_centre_pb.AddServiceCentreResponse) => void): grpcWeb.ClientReadableStream<service_centre_pb.AddServiceCentreResponse>;

  addServiceCentre(
    request: service_centre_pb.AddServiceCentreRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: service_centre_pb.AddServiceCentreResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/api.ServiceCentreService/AddServiceCentre',
        request,
        metadata || {},
        this.methodDescriptorAddServiceCentre,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/api.ServiceCentreService/AddServiceCentre',
    request,
    metadata || {},
    this.methodDescriptorAddServiceCentre);
  }

  methodDescriptorGetServiceCentreByID = new grpcWeb.MethodDescriptor(
    '/api.ServiceCentreService/GetServiceCentreByID',
    grpcWeb.MethodType.UNARY,
    service_centre_pb.GetServiceCentreByIDRequest,
    service_centre_pb.GetServiceCentreByIDResponse,
    (request: service_centre_pb.GetServiceCentreByIDRequest) => {
      return request.serializeBinary();
    },
    service_centre_pb.GetServiceCentreByIDResponse.deserializeBinary
  );

  getServiceCentreByID(
    request: service_centre_pb.GetServiceCentreByIDRequest,
    metadata: grpcWeb.Metadata | null): Promise<service_centre_pb.GetServiceCentreByIDResponse>;

  getServiceCentreByID(
    request: service_centre_pb.GetServiceCentreByIDRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: service_centre_pb.GetServiceCentreByIDResponse) => void): grpcWeb.ClientReadableStream<service_centre_pb.GetServiceCentreByIDResponse>;

  getServiceCentreByID(
    request: service_centre_pb.GetServiceCentreByIDRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: service_centre_pb.GetServiceCentreByIDResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/api.ServiceCentreService/GetServiceCentreByID',
        request,
        metadata || {},
        this.methodDescriptorGetServiceCentreByID,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/api.ServiceCentreService/GetServiceCentreByID',
    request,
    metadata || {},
    this.methodDescriptorGetServiceCentreByID);
  }

  methodDescriptorUpdateServiceCentre = new grpcWeb.MethodDescriptor(
    '/api.ServiceCentreService/UpdateServiceCentre',
    grpcWeb.MethodType.UNARY,
    service_centre_pb.UpdateServiceCentreRequest,
    service_centre_pb.UpdateServiceCentreResponse,
    (request: service_centre_pb.UpdateServiceCentreRequest) => {
      return request.serializeBinary();
    },
    service_centre_pb.UpdateServiceCentreResponse.deserializeBinary
  );

  updateServiceCentre(
    request: service_centre_pb.UpdateServiceCentreRequest,
    metadata: grpcWeb.Metadata | null): Promise<service_centre_pb.UpdateServiceCentreResponse>;

  updateServiceCentre(
    request: service_centre_pb.UpdateServiceCentreRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: service_centre_pb.UpdateServiceCentreResponse) => void): grpcWeb.ClientReadableStream<service_centre_pb.UpdateServiceCentreResponse>;

  updateServiceCentre(
    request: service_centre_pb.UpdateServiceCentreRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: service_centre_pb.UpdateServiceCentreResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/api.ServiceCentreService/UpdateServiceCentre',
        request,
        metadata || {},
        this.methodDescriptorUpdateServiceCentre,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/api.ServiceCentreService/UpdateServiceCentre',
    request,
    metadata || {},
    this.methodDescriptorUpdateServiceCentre);
  }

  methodDescriptorDeleteServiceCentre = new grpcWeb.MethodDescriptor(
    '/api.ServiceCentreService/DeleteServiceCentre',
    grpcWeb.MethodType.UNARY,
    service_centre_pb.DeleteServiceCentreRequest,
    service_centre_pb.DeleteServiceCentreResponse,
    (request: service_centre_pb.DeleteServiceCentreRequest) => {
      return request.serializeBinary();
    },
    service_centre_pb.DeleteServiceCentreResponse.deserializeBinary
  );

  deleteServiceCentre(
    request: service_centre_pb.DeleteServiceCentreRequest,
    metadata: grpcWeb.Metadata | null): Promise<service_centre_pb.DeleteServiceCentreResponse>;

  deleteServiceCentre(
    request: service_centre_pb.DeleteServiceCentreRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: service_centre_pb.DeleteServiceCentreResponse) => void): grpcWeb.ClientReadableStream<service_centre_pb.DeleteServiceCentreResponse>;

  deleteServiceCentre(
    request: service_centre_pb.DeleteServiceCentreRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: service_centre_pb.DeleteServiceCentreResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/api.ServiceCentreService/DeleteServiceCentre',
        request,
        metadata || {},
        this.methodDescriptorDeleteServiceCentre,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/api.ServiceCentreService/DeleteServiceCentre',
    request,
    metadata || {},
    this.methodDescriptorDeleteServiceCentre);
  }

  methodDescriptorGetServicesList = new grpcWeb.MethodDescriptor(
    '/api.ServiceCentreService/GetServicesList',
    grpcWeb.MethodType.UNARY,
    service_centre_pb.GetServicesListRequest,
    service_centre_pb.GetServicesListResponse,
    (request: service_centre_pb.GetServicesListRequest) => {
      return request.serializeBinary();
    },
    service_centre_pb.GetServicesListResponse.deserializeBinary
  );

  getServicesList(
    request: service_centre_pb.GetServicesListRequest,
    metadata: grpcWeb.Metadata | null): Promise<service_centre_pb.GetServicesListResponse>;

  getServicesList(
    request: service_centre_pb.GetServicesListRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: service_centre_pb.GetServicesListResponse) => void): grpcWeb.ClientReadableStream<service_centre_pb.GetServicesListResponse>;

  getServicesList(
    request: service_centre_pb.GetServicesListRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: service_centre_pb.GetServicesListResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/api.ServiceCentreService/GetServicesList',
        request,
        metadata || {},
        this.methodDescriptorGetServicesList,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/api.ServiceCentreService/GetServicesList',
    request,
    metadata || {},
    this.methodDescriptorGetServicesList);
  }

}

